var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-card',{attrs:{"bordered":false}},[_c('div',{staticClass:"pageContentBox"},[_c('div',{staticClass:"content-head"},[_c('div',{style:({height:'700px',width:'100%'}),attrs:{"id":"myChart"}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }